// Polls the Guide article show page while site_build_status is in_progress.
// Turbo Stream replaces only #guide_site_build_status (see refresh_build action).

import { Controller } from "@hotwired/stimulus"

const TERMINAL_STATUSES = new Set(["idle", "live", "failed"])

export default class extends Controller {
  static values = {
    refreshUrl: String,
    metaId: String,
    interval: { type: Number, default: 3000 },
  }

  connect() {
    if (!this._isTerminal()) {
      this._startPolling()
    }
  }

  disconnect() {
    this._stopPolling()
  }

  _isTerminal() {
    const meta = document.getElementById(this.metaIdValue)
    if (!meta) return true
    return TERMINAL_STATUSES.has(meta.dataset.siteBuildStatus)
  }

  _startPolling() {
    if (this._timer) return
    this._timer = setInterval(() => this._poll(), this.intervalValue)
  }

  _stopPolling() {
    if (!this._timer) return
    clearInterval(this._timer)
    this._timer = null
  }

  async _poll() {
    if (!this.hasRefreshUrlValue) return
    try {
      const url = new URL(this.refreshUrlValue, window.location.origin)
      url.searchParams.set("_t", Date.now())
      const response = await fetch(url.toString(), {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-Requested-With": "XMLHttpRequest",
        },
        credentials: "same-origin",
      })
      if (!response.ok) return
      const contentType = response.headers.get("Content-Type") || ""
      if (!contentType.includes("turbo-stream")) return

      const html = await response.text()
      Turbo.renderStreamMessage(html)

      if (this._isTerminal()) {
        this._stopPolling()
      }
    } catch (_) {
      // ignore transient network errors — next interval retries
    }
  }
}
